<template>
  <nuxt-link
    :to="{
      name: PageKey.TUTORIAL_INFO,
      params: { id: data.id },
    }"
  >
    <div class="tutorial-other-card">
      <div class="cover">
        <Resource
          :src="data.cover_url"
          class="w-[142px] h-full object-cover rounded-[8px]"
          :transform-resource="transformImage"
        />
        <div class="time">
          {{ formatDuration(data?.video_duration * 1000) }}
        </div>
      </div>
      <div class="flex flex-col justify-between">
        <div class="name">
          {{ data.name }}
        </div>
        <div class="flex-y-center mt-[10px] gap-[5px]">
          <Resource
            v-if="data?.logo_url"
            class="w-[18px] h-[18px] rounded-[50%]"
            :src="data?.logo_url"
            :transform-resource="transformImage"
          />
          <span class="text-[12px] text-font-40">{{ data?.team_name }}</span>
        </div>
      </div>
    </div>
  </nuxt-link>
</template>

<script setup lang="ts">
import { PageKey } from '~/constants/page'
import { useTime } from '~/hooks/useTime'

const { formatDuration } = useTime()

const props = defineProps<{
  data: any
}>()
</script>

<style lang="scss" scoped>
.tutorial-other-card {
  @apply flex gap-[8px];
  .cover {
    @apply relative h-[80px];
    .time {
      @apply absolute bottom-[6px] right-[6px] rounded-[12px] text-[12px] p-[4px_7px];
      background: rgba(0, 0, 0, 0.4);
      color: white;
    }
  }
  .name {
    @apply text-14 text-font-1 line-clamp-2 font-semibold;
  }
  &:hover {
    .name {
      @apply text-primary;
    }
  }
}
</style>
